module.exports = __webpack_public_path__ + "img/login.64a6a40f.png";